export default function sanitizeSlug(
  slug,
  options = { removeTrailingDashes: false, useNullForEmpty: false }
) {
  let sanitizedSlug = slug.replace(/ /g, "-"); // replace spaces with dashes
  sanitizedSlug = sanitizedSlug.replace(/--/g, "-"); // replace double dash with single dash
  sanitizedSlug = sanitizedSlug.replace(/^-/g, ""); // no dashes at beginning of slug
  sanitizedSlug = sanitizedSlug.replace(/[^A-Za-z0-9-]/g, ""); // replace unallowed chars with empty string
  sanitizedSlug = sanitizedSlug.toLowerCase();
  if (options.removeTrailingDashes) {
    sanitizedSlug = sanitizedSlug.replace(/-+$/g, ""); // no dashes at end of slug
  }
  if (options.useNullForEmpty && !sanitizedSlug) {
    return null;
  }
  return sanitizedSlug;
}
